<template>
    <div>
        <div class="ui segment good-card row">
            <div class="ui grid">
                <div class="row">
                    <div class="column eight wide computer sixteen wide tablet">
                        <div>
                            <div class="badge-wrapper">
                                <discount-tag v-bind:item="item"></discount-tag>
                                <div v-for="badge in item.badges" class="ui labels">
                                    <a class="ui label"
                                        :style="{ backgroundColor: '#'+badge.color, color: '#210404'}">{{badge.label}}</a>
                                </div>
                            </div>
                        </div>

                        <g-zoom :item="item"></g-zoom>
                    </div>
                    <div class="column eight wide computer sixteen wide tablet">
                        <h1>{{ item.goods_name }}</h1>
                        <p>{{ item.description }}</p>
                        <a class="read-more" href="javascript:void(0)" @click="gotoMoreDescription()">Lasīt vairāk</a>
                        <br>
                        <div class="meta">
                            <div class="ui tag labels pa-tag-wrapper">
                                <price-tag v-bind:item="item" v-bind:oneline="true"></price-tag>
                                <a v-if="item.bail>0" class="ui green label">Drošības nauda: {{item.bail}} &euro;</a>
                                <auto-ship v-bind:item="item"></auto-ship>
                            </div>
                            <div v-if="item.deposit != 0" class="deposit-info">
                              + Depozīts: {{item.deposit}} &euro;
		                    </div>
                        </div>
                        <br>
                        <div class="ui form">
                            <div class="ui items">
                                <div class="item">
                                    <div class="ui grid">
                                        <div class="sixteen wide column">
                                            <div class="ui right floated">
                                                <div class="ui left floated inline fields">
                                                    <label style="width:85px; text-align:right">Pasūtīšu: &nbsp;
                                                        x</label>
                                                    <div class="field">
                                                        <input type="text" placeholder="skaits"
                                                            @keyup="updateCartItemOrder($event.target.value)"
                                                            :value="cartItem.order" style="width:70px" number>
                                                    </div>
                                                </div>
                                                <div class="ui left floated inline fields"
                                                    v-if="cartItem.isrentable == 1">
                                                    <label style="width:85px; text-align:right">Atgriezīšu: &nbsp;
                                                        x</label>
                                                    <div class="field">
                                                        <input type="text" placeholder="skaits"
                                                            @keyup="updateCartItemReturn($event.target.value)"
                                                            :value="cartItem.return" style="width:70px" number>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br>





                        <div v-if="!checkIfInCart(item)" id="add-first-item-button"
                            @click="addItemToCart(item, item.id, $event.target)" class="ui bottom attached button">
                            <i class="add icon"></i> Pievienot
                        </div>
                        <div v-else class="ui three bottom attached buttons">
                            <div class="ui button minus-icon-container" @click="reduceItemInCart(item)">
                                <i class="minus icon"></i>
                            </div>
                            <button v-on:click="$router.push({name:'cart'})" class="ui vertical animated button">
                                <div class="ui hidden content">Uz grozu</div>
                                <div class="ui visible content">
                                    <i class="cart icon"></i>
                                    {{howManyInCart(item)}} gab.
                                </div>
                            </button>
                            <div class="ui button" @click="addItemToCart(item, item.id, $event.target)">
                                <i class="add icon popup" :id="'good_item_'+item.id"
                                    data-content="Diemžēl pieejamo preču skaits noliktavā ir ierobežots, lūdzu apskatiet zemāk līdzīgās preces."></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="column long-description-box">
                        <p id="long-description" v-html="item.long_description"></p>
                    </div>
                </div>
            </div>
        </div>
        <div>

            <replacement-goods v-if="replacement.length>0" :goods="replacement"></replacement-goods>
            <complementary-goods v-if="complementary.length>0" :goods="complementary"></complementary-goods>
        </div>




    </div>

</template>


<script>
    import gZoom from "../GoodZoom";
    import autoShip from "../AutoShip";
    import price from "../Price";
    import discount from "../Discount";
    // import TopGoods from "../HomeTopGoods";
    import api from "../../store/api";
    import replacement_goods from "../ReplacementGoods";
    import complementary_goods from "../ComplementaryGoods";
    import { setTimeout } from 'timers';
    // import CategoryMenu from './CategoryMenu'


    export default {
        components: {
            gZoom,
            // CategoryMenu,
            // "top-goods": TopGoods,
            "auto-ship": autoShip,
            "price-tag": price,
            "discount-tag": discount,
            "replacement-goods": replacement_goods,
            "complementary-goods": complementary_goods
        },
        data() {
            return {
                isactive: false,
                replacement: [], //replacement goodsarray
                complementary: [], // complementary  goods array
                extraGoodsHaveLoaded: false,
                itemCountInCart: 0,
                replacementHaveLoaded: false,
                complementaryHaveLoaded: false,
            };
        },

        computed: {
            searchTerm() {
                return this.$store.state.categoryStore.searchTerm
            },
            item() {
                return this.$store.state.goodStore.item;
            },
            cart() {
                return this.$store.state.cartStore.activeCart;
            },
            cartItems() {
                return this.$store.state.cartStore.items;
            },
            cartItem() {
                var self = this;
                var items = this.$store.state.cartStore.items.filter(function (e) {
                    return e.good_id == self.item.id;
                });
                if (items.length > 0) {
                    return items[0];
                } else {
                    return {
                        order: 0
                    };
                }
            },
            comp() {
                if (this.complementaryHaveLoaded === false) {

                    this.complementary_goods(item.alternative_goods);
                }
            }
        },
        // beforeMount() {
        //     // this.loadActiveCart()
        //     this.loadGoods()

        // },
        // mounted() {
        //     // this.loadActiveCart()
        //     this.loadGoods()

        // },
        // activated: function () {
        //     this.loadGoods()

        //     // console.log(this.$parent)
        // },
        created: function () {
            this.isactive = true; //used to ensure that when route keeps changing we dont reload data while component is not visible
            // this.isactive = true; //used to ensure that when route keeps changing we dont reload data while component is not visible
            // console.log(this.$parent)
            // this.loadActiveCart()
            this.loadGoods()
            this.checkIfInCart()
        },

        deactivated: function () {
            this.isactive = false;
            this.complementary = [];
            this.replacement = [];
            //clear selected good
            // this.$store.commit("SET_GOOD_ITEM", {});
        },


        watch: {
          //"$route.params": "loadGoods",
          //"$route.params": "get_replacement_goods",
          //"$route.params": "get_complementary_goods"
        },

        methods: {
            loadGoods() {
                // console.log(1)
                if (!this.isactive) {
                // console.log(2)

                    return
                }
                // console.log(3)

                if (this.extraGoodsHaveLoaded === true) {
                // console.log(4)

                    return
                }
                // console.log(5)
                //as this is called by watcher then first check if component is activated
                var goodId = this.$route.params.id ? this.$route.params.id : 1;
                this.$store
                    .dispatch("loadSingleGoodByLink", goodId)
                    .then(response => {

                        // if (response.data.data.check_in_warehouse == 0) {

                        //     this.get_complementary_goods(response.data.data.alternative_goods);
                        // } else {

                            if (this.complementaryHaveLoaded === false ) {

                                this.get_complementary_goods(response.data.data.alternative_goods);
                            }

                        // }
                    })
                    .then(() => {
                        this.extraGoodsHaveLoaded = true
                    })
                    .catch(error => {
                        // console.log(error);
                        // this.$router.push("/");
                    });
            },
            get_complementary_goods(item) {
                if (this.complementaryHaveLoaded === true) {
                    return
                } else {


                    var array = [];
                    // console.log(this.item.id);
                    this.complementaryHaveLoaded = true

                    for (var id of item) {
                        api
                            .get("goods/" + id)
                            .then(function (response) {
                                if (item.check_in_warehouse == 1) {
                                    if (response.data.data.available_for_customer > 0) {
                                        array.push(response.data.data);
                                    }
                                    this.complementaryHaveLoaded = true
                                } else {
                                    array.push(response.data.data);
                                }
                            })
                            .catch(function (error) {
                                // commit("LOADING_GOOD", false);
                            });
                    }
                    this.complementary = array;
                }

            },
            //fetch replacement goods
            get_replacement_goods(item) {
                if (this.replacementHaveLoaded === true) {
                    return
                } else {

                    var array = [];
                    for (var id of item) {
                        api
                            .get("goods/" + id)
                            .then(function (response) {
                                if (response.data.data.available_for_customer) {
                                    array.push(response.data.data);
                                }
                                this.replacementHaveLoaded = true

                            })
                            .catch(function (error) {
                                // commit("LOADING_GOOD", false);
                            });
                    }
                    this.replacement = array;
                }
            },

            //fetch complementary goods

            realPrice(item) {
                if (this.checkIfInCart(item)) {
                    var cartItem = this.$store.state.cartStore.items.filter(function (e) {
                        return e.good_id == item.id;
                    });

                    return cartItem[0].price_vat;
                } else return item.base_price_vat;
            },

            checkIfInCart(item) {
                if (
                    this.$store.state.cartStore.items.length > 0 &&
                    this.$store.state.cartStore.items.filter(function (e) {
                        return e.good_id == item.id;
                    }).length > 0
                ) {
                    // console.log($("#add-first-item-button").addClass("hidden"))
                    return true;
                } else {
                    // console.log($("#add-first-item-button").removeClass("hidden"))
                    return false;
                }
                this.itemCountInCart = this.$store.state.cartStore.items.length

            },

            addItemToCart(item, index, eventTarget) {
                // console.log("_______________________Start of: addItemToCart at GoodCard.vue__________________")

                // console.log("event.target at addItemToCart")
                // console.log(eventTarget)


                // console.log("this in the context of addItemToCart")
                // console.log(this)

                if (eventTarget.className === "minus icon" || eventTarget.className === "ui button minus-icon-container" ) {
                    return
                } else {




                    var itemInCart = this.checkIfInCart(item);
                    if (itemInCart) {
                        var cartItem = this.$store.state.cartStore.items.filter(function (e) {
                            return e.good_id == item.id;
                        });
                        var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object

                        // console.log("at if 1 in addItemToCart")

                        updatedItem.order++;
                    } else {
                        // console.log("at else in addItemToCart")
                        var updatedItem = {
                            order: 1,
                            good_id: item.id
                        };
                    }
                    // console.log(updatedItem);
                    //inform facebook
                    this.$store
                        .dispatch("addCartItem", [this.cart.id, updatedItem])
                        .then(response => {
                            // console.log("at callback of addCartItem store call, in addItemToCart. Response for callback:")
                            // console.log(response)
                            let outOfStockMessage = "Diemžēl pieejamo preču skaits noliktavā ir ierobežots, lūdzu apskatiet zemāk līdzīgās preces."

                            if (item.check_in_warehouse == 0) {


                                //no need to show replacement goods below checks will be skipped
                                if (this.complementaryHaveLoaded === true) {

                                } else {

                                    this.get_complementary_goods(item.alternative_goods);
                                }

                            } else if (item.available_for_customer < updatedItem.order && item.available_for_customer == 0) {
                                // console.log("at else if at addCartItem")

                                let outOfStockMessage = "Diemžēl noliktavā šobrīd šīs preces nav. Drīzumā plānojam to saņemt. Ja preču atlikums ir 0, tad reģistrētam klientam - tiklīdz prece atkal būs pieejama, tiks automātiski nosūtīts paziņojums uz e-pastu!"



                                if (item.related_goods.length > 0) {
                                    if (this.replacementHaveLoaded === true) {
                                        return
                                    } else {

                                        this.get_replacement_goods(item.related_goods);
                                    }

                                    if (item.related_goods.length < 1 && item.alternative_goods.length < 1) {
                                        $("#good_item_" + item.id).attr('data-content', outOfStockMessage);
                                        $("#good_item_" + item.id).popup("show");
                                    }

                                    $("#good_item_" + item.id).popup("show");
                                    // setTimeout(
                                    //   function () {
                                    //     $("#good_item_" + item.id).popup("destroy");
                                    //   }.bind(this),
                                    //   1000
                                    // );
                                    this.$scrollTo('#replac');


                                } else {


                                    $("#good_item_" + item.id).attr('data-content', outOfStockMessage);
                                    $("#good_item_" + item.id).popup("show");


                                }



                                // var elmnt = document.getElementById("replac");
                                // elmnt.scrollIntoView();

                            } else if (item.available_for_customer < updatedItem.order && item.available_for_customer > 0) {

                                // console.log("at else if 2 at addcartItmes")

                                // console.log("this.replacement.length at addcartItems:")
                                // console.log(this.replacement.length)

                                if (item.related_goods.length > 0 && this.replacementHaveLoaded === false) {

                                    this.get_replacement_goods(item.related_goods);
                                }
                                if (item.alternative_goods.length > 0 && this.complementaryHaveLoaded === false) {


                                    this.get_complementary_goods(item.alternative_goods);
                                    $("#good_item_" + item.id).popup("show");
                                } else {


                                    $("#good_item_" + item.id).attr('data-content', outOfStockMessage);
                                    $("#good_item_" + item.id).popup("show");

                                }
                                // setTimeout(
                                //   function () {
                                //     $("#good_item_" + item.id).popup("destroy");
                                //   }.bind(this),
                                //   10000
                                // );
                                // this.$scrollTo('#replac');
                            } else {
                                // this.$store.dispatch("loadActiveCart", this.cart.id);
                            }
                            fbq("track", "AddToCart", {
                                content_name: response.data.data.name,
                                content_category: "Water",
                                content_ids: [response.data.data.good_id],
                                content_type: "product",
                                value: response.data.data.price_vat,
                                currency: "EUR"
                            });
                        })
                        .then(() => {

                            // console.log("_______________________End of: addItemToCart at GoodCard.vue__________________")
                        })
                        .catch(error => {
                            console.error("Cart was not loaded");
                            // console.log(error)
                        });

                }


            },
            howManyInCart(item) {
                if (this.checkIfInCart(item)) {
                    var cartItem = this.$store.state.cartStore.items.filter(function (e) {
                        return e.good_id == item.id;
                    });
                    item.autoship_price = cartItem[0].autoship_price;
                    return cartItem[0].order;
                } else return 0;
            },
            updateCartItemReturn: _.debounce(function (returnItems) {


                var self = this;
                if (this.item != undefined && this.checkIfInCart(this.item)) {
                    var cartItem = this.$store.state.cartStore.items.filter(function (e) {
                        return e.good_id == self.item.id;
                    });
                    var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
                    updatedItem.return = returnItems;
                    this.$store
                        .dispatch("addCartItem", [this.cart.id, updatedItem])
                        .then(response => {
                            this.$store.dispatch("loadActiveCart", this.cart.id);
                        })
                        .catch(error => {
                            console.error("Cart was not loaded");
                        });
                }
            }, 500),

            updateCartItemOrder: _.debounce(function (order) {

                var self = this;
                if (order == "") return;
                //if(order == 0) this.removeItem(item)
                else {
                    if (this.item != undefined && this.checkIfInCart(this.item)) {
                        var cartItem = this.$store.state.cartStore.items.filter(function (e) {
                            return e.good_id == self.item.id;
                        });
                        var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
                        updatedItem.order = order;
                    } else {
                        var updatedItem = {
                            order: order,
                            good_id: this.item.id
                        };
                    }

                    this.$store
                        .dispatch("addCartItem", [this.cart.id, updatedItem])
                        .then(response => {
                            this.$store.dispatch("loadActiveCart", this.cart.id);
                            self.item.order = updatedItem.order;
                        })
                        .catch(error => {
                            console.error("Cart was not loaded");
                        });
                }
            }, 500),


            gotoMoreDescription: function () {
                $(window).scrollTop($("#long-description").offset().top);
            },

            loadActiveCart() {
                this.$store
                    .dispatch("loadActiveCart")
                    .then(response => {
                        this.$store.dispatch("loadCartItems", response.data.data.id);
                    })
                    .catch(error => {
                        if (error.response && error.response.status == 404) {
                            //if there is no active cart then create new cart
                            this.$store.dispatch("createCart");
                        }
                    });
            },
            reduceItemInCart(item) {

                $("#good_item_" + item.id).popup("destroy"); //remove warning about warehouse goods
                var itemInCart = this.checkIfInCart(item);

                if (itemInCart) {
                    var cartItem = this.$store.state.cartStore.items.filter(function (e) {
                        return e.good_id == item.id;

                    });
                    var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
                    updatedItem.order--;
                    // console.log("updatedItem gotten from this.$store.state.cartStore.items at reduceItemInCart at GoodCard.vue, After decreasing")
                    // console.log(updatedItem);
                    this.$store
                        .dispatch("addCartItem", [this.cart.id, updatedItem])
                        .then(response => {
                            item.autoship_price = response.data.data.autoship_price;
                            //if item is totaly removed then remove it from store
                            this.$store.dispatch("loadActiveCart", this.cart.id);
                            this.outofstock = "";
                        })
                        .catch(error => {
                            console.error("Cart was not loaded");
                            // console.log(error)
                        });
                }
            },
        },


        // metaInfo() {
        //   return {
        //       title: `- Epiloge`,
        //       meta: [
        //           { name: 'description', content: 'Connect and follow'},
        //           { property: 'og:title', content:  ' - Epiloge'},
        //           { property: 'og:site_name', content: 'Epiloge'},
        //           { property: 'og:description', content: 'Connect and follow'},
        //           {property: 'og:type', content: 'profile'},
        //           {property: 'og:url', content: 'https://epiloge.com/@' },
        //           {property: 'og:image', content: '/users/' }    
        //       ]
        //   }
        // }

    };




</script>


<style scoped>
  .hidden {
      display: none !important;
      overflow: hidden !important;
  }

  .ui.attached.segment {
      margin: 0px;
      width: auto;
      border: none;
  }

  #long-description {
      margin: 15px 0 !important;
  }

  a.read-more {
      color: #b4b1ab !important;
      display: inline-block;
      margin-bottom: 15px;
  }

  a.read-more:hover {
      color: #dadada !important;
  }
  .badge-wrapper {
      display: flex;
      align-items: flex-end;
  }
  .good-card {
      /* margin-top: 30px!important; */
      overflow: hidden;
      border: none !important;
      box-shadow: none !important;
  }
  .deposit-info {
    font-size: 1em;
    color: rgba(0, 0, 0, 0.4);
  }
</style>


// WEBPACK FOOTER //
// GoodCard.vue?3619ebcb